import { createFeatureSelector } from '@ngrx/store';
import { AddStoreState, EditStoreState, StoreSearchState } from '../models/store.model';
import { AddStoreReducer } from './add-store.reducer';
import { EditStoreReducer } from './edit-store.reducer';
import { StoreManagementReducer } from './search.reducer';

export const featureStoreManagementName = 'StoreManagement';

export interface DragonflyStoreState {
  storeManagement: StoreSearchState;
  editStore: EditStoreState;
  addStore: AddStoreState;
}

export const moduleStoreManagementReducers = {
  storeManagement: StoreManagementReducer,
  editStore: EditStoreReducer,
  addStore: AddStoreReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyStoreState>(featureStoreManagementName);
